import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import grigoraIcon from "../assets/grigora-icon.svg";

export default function SidebarLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="h-screen w-full bg-slate-50 flex text-slate-900 font-sans overflow-hidden">
      <Sidebar
        mobileOpen={mobileMenuOpen}
        onMobileClose={() => setMobileMenuOpen(false)}
      />

      {/* Main Content Container */}
      <main className="flex-1 md:ml-64 flex flex-col h-screen overflow-hidden transition-all duration-300 min-w-0">
        {/* Mobile-only compact header */}
        <div className="md:hidden shrink-0 border-b border-slate-200 bg-white px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              type="button"
              className="p-1.5 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
              onClick={() => setMobileMenuOpen(true)}
              aria-label="Open menu"
            >
              <Menu size={22} />
            </button>
            <div className="flex items-center gap-2">
              <img src={grigoraIcon} alt="Grigora" className="w-6 h-6 object-contain" />
              <span className="font-bold text-slate-900 text-lg">
                Grigora <span className="text-[#623ce7] text-xs font-semibold align-top">Admin</span>
              </span>
            </div>
          </div>
        </div>

        {/* Page Content Viewport */}
        <div className="flex-1 p-6 md:p-8 overflow-y-auto min-h-0">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
